import React from "react";
import DOMPurify from 'dompurify';

import './ListingEntry.css';

function ListingEntry(props){

  return (
    <li className={`listing ${props.logo ? 'has-logo' : ''}`}>
      {props.logo && <a className="logo" href={ `/listing/${props.slug}` }>
        {props.logo_ext !== 'svg' && <picture>
          <source srcSet={ `${props.logo[0]}.webp 1x, ${props.logo[1]}.webp 2x` } type="image/webp" />
          <source srcSet={ `${props.logo[0]} 1x, ${props.logo[1]} 2x` } type={`image/${props.logo_ext}`} />
          <img src={ props.logo[0] } alt={ props.title } />
        </picture>}
        {props.logo_ext === 'svg' && <img src={ props.logo[0] } alt={ props.title } />}
      </a>}
      <div>
        <a href={ `/listing/${props.slug}` }><h3 dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.title) }} /></a>
        <div 
          className='excerpt' 
          dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.excerpt) }}
          />
      </div>
      <a href={ `/listing/${props.slug}` } role="button" className="wp-block-ucc-button view-listing compact dr">View Listing</a>
    </li>
  );
}

export default ListingEntry;